<div id="company_search_container" class="formfield">
  <label class="formfield__label company__label">
    {{ "COMPANY_DATA.INPUT.COMPANY.LABEL" | translate }}
  </label>
  <div class="formfield__inputContainer">
    <ns-type-ahead
      suggestIcon="autosuggest__link--poi"
      (suggestionSelected)="onSelectedCompany($event)"
      (focus)="onFocus()"
      (focusout)="onFocusOut()"
      [autoFocus]="selectedCompany == null"
      [placeholder]="'COMPANY_DATA.INPUT.COMPANY.PLACEHOLDER' | translate"
      [searchControl]="searchControl"
      [searchFn]="searchFn"
      [privacySensitive]="true"
    >
    </ns-type-ahead>

    @if (companyRequiredError) {
      <nes-error-message>
        {{ companyRequiredError }}
      </nes-error-message>
    }

    <div *ngIf="companyLoading" class="basicLoader"></div>
  </div>
</div>

<div *ngIf="companyFetching; else company" class="basicLoader"></div>

<ng-template #company>
  <ng-container *ngIf="selectedCompany">
    <div class="formfield">
      <div class="formfield__inputContainer">
        <div class="grey__tile animated pulse" [cypress]="'company_result'">
          <a
            [cypress]="'company_close'"
            class="closeButton"
            (click)="closeCompany()"
          >
            <i class="icon"></i>
          </a>
          <div class="company__content" privacySensitive>
            <nes-heading
              tag="h2"
              size="base"
              weight="normal"
              class="nes-mb-3"
              >{{ "COMPANY" | translate }}</nes-heading
            >
            <nes-heading tag="h2" size="base" class="nes-mb-3">
              <strong>{{ selectedCompany.name }}</strong>
            </nes-heading>
            <div>{{ "KVK" | translate }}: {{ selectedCompany.kvkNumber }}</div>
            <ng-container *ngIf="selectedCompany.address as address">
              <div>
                {{ address.street }} {{ address.houseNumber }}
                {{ address.addition }}
              </div>
              <div>{{ address.postcode }} {{ address.city }}</div>
            </ng-container>
            <nes-text class="headingXXS mt-2">
              {{ "COMPANY_DATA.SEARCH_RESULT.MESSAGE" | translate }}
            </nes-text>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
